import { render, staticRenderFns } from "./ImageDisplay.vue?vue&type=template&id=6e67202f&scoped=true&"
import script from "./ImageDisplay.vue?vue&type=script&lang=js&"
export * from "./ImageDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ImageDisplay.vue?vue&type=style&index=0&id=6e67202f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e67202f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
